// removed by extract-text-webpack-plugin
module.exports = {"settings":"_2go6FiVSQTYaGb0qeUJC9j","radioItem":"DFAoeMmqKTxr_WS8rBdvT"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MainMenu/Settings.scss
// module id = 836
// module chunks = 0